import { render, staticRenderFns } from "./TimeZoneJson.vue?vue&type=template&id=35d1c9d3&scoped=true&"
import script from "./TimeZoneJson.vue?vue&type=script&lang=ts&"
export * from "./TimeZoneJson.vue?vue&type=script&lang=ts&"
import style0 from "./TimeZoneJson.vue?vue&type=style&index=0&id=35d1c9d3&lang=scss&scoped=true&"
import style1 from "./TimeZoneJson.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d1c9d3",
  null
  
)

export default component.exports